<script setup lang="ts">
import CourseStepView from 'modules/Course/views/CourseStepView/CourseStepView.vue';
import BPage from 'src/shared/components/base/BPage/BPage.vue';
// import { useRepo } from 'pinia-orm';
// import { UserSection } from 'src/modules/Section/models/UserSection';
// import useBreadcrumbs from 'shared/composables/useBraedcrumbs';
// import { useRoute } from 'vue-router';
// import { watchEffect } from 'vue';

// const userSectionRepo = useRepo(UserSection);
// const route = useRoute();

// const { userSectionDocId } = route.params;
// watchEffect(() => {
//   if (userSectionDocId) {
//     const userSection = userSectionRepo
//       .where('documentId', userSectionDocId as string)
//       .first();
//     if (userSection) {
//       const bc = useBreadcrumbs();
//       bc.setUserSection(userSection);
//     }
//   }
// });
</script>

<template>
  <BPage>
    <div class="col fit">
      <CourseStepView />
    </div>
  </BPage>
</template>
